// extracted by mini-css-extract-plugin
export default {"buttonContainer":"styles_buttonContainer__LX6Fv","link":"styles_link__pI+hN"};